const utils = require('frontend-controller/lib/utils')

module.exports = {
	forceScope: 'art_crm',
	config: {
		staticLookupName: 'artCrmController'
	},

	model: {
		activityYear: 0
	},

	methods: {
		propertiesFormChangeView: function(type, options){
			options = options || {};
			if(options.$container){
				if(type === 'address'){

					if(options.addressType === 'journalist'){
						options.$container.find('[data-field-code="journalist_infoInAdvance"], [data-field-code="journalist_infoInAdvanceXXL"]')
							.removeAttr('disabled', 'disabled')
							.closest('.field')
							.show()
						;
					} else {
						options.$container.find('[data-field-code="journalist_infoInAdvance"], [data-field-code="journalist_infoInAdvanceXXL"]')
							.attr('disabled', 'disabled')
							.closest('.field')
							.hide()
						;
					}

					if(options.addressType === 'media'){
						options.$container.find('[data-field-code="media_circulation"], [data-field-code="media_pagePrice"]')
							.removeAttr('disabled', 'disabled')
							.closest('.field')
							.show()
						;
						options.$container.find('[data-field-code="salutation"], [data-field-code="UID"], [data-field-code="title"], [data-field-code="firstname"], [data-field-code="lastname"]')
							.attr('disabled', 'disabled')
							.closest('.field')
							.hide()
							.closest('div.group')
							.hide()
						;
					} else {
						options.$container.find('[data-field-code="salutation"], [data-field-code="UID"], [data-field-code="title"], [data-field-code="firstname"], [data-field-code="lastname"]')
							.removeAttr('disabled', 'disabled')
							.closest('.field')
							.show()
							.closest('div.group')
							.show()
						;
						options.$container.find('[data-field-code="media_circulation"], [data-field-code="media_pagePrice"]')
							.attr('disabled', 'disabled')
							.closest('.field')
							.hide()
						;
					}

					if(options.addressType === 'contact'){
						options.$container.find('[data-field-code="addressType"]')
							.attr('disabled', 'disabled')
							.closest('.field')
							.hide()
						;
						options.$container.find('[data-field-code="contactName"]')
							.removeAttr('disabled', 'disabled')
							.closest('.field')
							.show()
						;
					} else if (options.usage === 'selection' && !options.grantAllAddressTypes) {
						options.$container.find('[data-field-code="addressType"]')
							.attr('disabled', 'disabled')
							.closest('.field')
							.hide()
						;
					} else {
						options.$container.find('[data-field-code="addressType"]')
							.removeAttr('disabled', 'disabled')
							.closest('.field')
							.show()
						;
						options.$container.find('[data-field-code="contactName"], [data-field-code="email"], [data-field-code="phone"], [data-field-code="fax"], [data-field-code="website"], [data-field-code="mobile"], [data-field-code="emailNewsletter"]')
							.attr('disabled', 'disabled')
							.closest('.field')
							.hide()
						;
					}

					try {
						let toggle
						const disableFilters = (options.selectionOptions || {}).disableFilters || {}

						for(const fieldCode of ['connectionInclusive', 'hasActiveNewsletterEmail']){
							toggle = getComponent(
								options.$container.find(`[data-field-code="${fieldCode}"]`)
									.closest('.field')
									.find('.base_form_fields_toggle'),
								true
							)
							if(toggle){
								if (options.usage === 'selection' && disableFilters[fieldCode]) {
									toggle.disable()
								} else {
									toggle.enable()
								}
							}
						}
					} catch(error){} // swallow errors due to missing filter fields

					// NOTE: handle type dependent fields?! --> NO!
					// if(options.isCompany){
					// 	options.$container.find('[data-field-code="UID"], [data-field-code="organisationName"]')
					// 		.removeAttr('disabled', 'disabled')
					// 		.closest('.field')
					// 		.show()
					// 	;
					// 	options.$container.find('[data-field-code="firstname"], [data-field-code="lastname"], [data-field-code="salutation"]')
					// 		.attr('disabled', 'disabled')
					// 		.closest('.field')
					// 		.hide()
					// 	;
					// } else {
					// 	options.$container.find('[data-field-code="UID"], [data-field-code="organisationName"]')
					// 		.attr('disabled', 'disabled')
					// 		.closest('.field')
					// 		.hide()
					// 	;
					// 	options.$container.find('[data-field-code="firstname"], [data-field-code="lastname"], [data-field-code="salutation"]')
					// 		.removeAttr('disabled', 'disabled')
					// 		.closest('.field')
					// 		.show()
					// 	;
					// }
				}
			}
		},

		showInsert: function(type){
			var self = this;
			var entityTitle = '';
			var entityIcon = '';
			var typeGranted = false;
			var baseActionKey = 'showInsert_' + (type || '');

			if(type === 'address'){
				typeGranted = true;
				entityTitle = storage.__('addresses.tabs.new.title');
				entityIcon = 'fi fi-address';
			} else if(type === 'trip'){
				typeGranted = true;
				entityTitle = storage.__('trips.tabs.new.title');
				entityIcon = 'fi fi-trip';
			} else if(type === 'activity' && options.addressID){
				typeGranted = true;
				entityTitle = storage.__('activities.tabs.new.title');
				entityIcon = 'fi fi-activity';
			} else if(type === 'cooperation'){
				typeGranted = true;
				entityTitle = storage.__('cooperations.tabs.new.title');
				entityIcon = 'fi fi-cooperation';
			}

			if(typeGranted && self.actions[baseActionKey]){
				return self.performAndStoreAction(
					undefined,
					this.prepareAction(baseActionKey, undefined, {
						tabOptions: {
							title: entityTitle,
							icon: entityIcon
						}
					}),
					true
				);
			}

			return utils.promise.reject();
		},

		showEdit: function(type, entityID, entityData, refreshExistingTab, tabStrip, tabRegisterSecret, refreshTabContents = true){
			const baseActionKey = 'showEdit_' + (type || '')
			const entityAttributes = (entityData || {}).attributes || {}
			let entityPrefix = ''
			let entityTitle = ''
			let entityIcon = ''
			let mediaTitle = ''
			let performActionGranted = false
			let actionSuffix = ''
			let afterActionCallback

			if(type === 'address'){
				performActionGranted = true
				entityPrefix = storage.__('addresses.tabs.title.prefix.' + (entityAttributes.addressType || 'default'))
				entityIcon = 'fi fi-address-type'
				mediaTitle = (entityData.parentEntity || {}).mediaTitle || entityAttributes.mediaTitle
				if(entityAttributes.addressType){
					entityIcon += '-' + entityAttributes.addressType
				}
				if(entityAttributes.addressTitle){
					entityTitle = entityAttributes.addressTitle
				}
				else if(entityAttributes.addressType === 'journalist'){
					entityTitle = [
						[entityAttributes.lastname, entityAttributes.firstname].filter(value => !!value).join(' '),
						entityAttributes.organisationName
					].filter(value => !!value).join(' - ')
					if(mediaTitle){
						entityTitle += ` [ ${mediaTitle} ]`
					}
				}
				else {
					entityTitle = entityAttributes.organisationName || ((entityAttributes.lastname || '') + ' ' + (entityAttributes.firstname || ''))
				}
				actionSuffix = entityID
			} else if(type === 'trip') {
				performActionGranted = true
				entityPrefix = storage.__('trips.tabs.title.prefix.default')
				entityIcon = 'fi fi-trip'
				if(entityAttributes.clientTitle) 	entityTitle = entityAttributes.clientTitle;
				else  								entityTitle = entityAttributes.organisationName || ((entityAttributes.lastname || '') + ' ' + (entityAttributes.firstname || ''));
				actionSuffix = entityID
			} else if(type === 'activity') {
				performActionGranted = true
				entityPrefix = storage.__('activities.tabs.title.prefix.default')
				entityIcon = 'fi fi-activity'
				this.model.activityYear = entityAttributes.activityYear || (new Date()).getFullYear()
				if(entityAttributes.addressTitle) 	entityTitle = entityAttributes.addressTitle;
				else  								entityTitle = entityAttributes.organisationName || ((entityAttributes.lastname || '') + ' ' + (entityAttributes.firstname || ''));
				entityTitle = this.model.activityYear + ' - ' + entityTitle
				actionSuffix = entityID + '_' + this.model.activityYear
			} else if(type === 'cooperation') {
				performActionGranted = true
				entityPrefix = storage.__('cooperations.tabs.title.prefix.default')
				entityIcon = 'fi fi-cooperation'
				if(entityAttributes.clientTitle) 	entityTitle = entityAttributes.clientTitle;
				else  								entityTitle = entityAttributes.organisationName || ((entityAttributes.lastname || '') + ' ' + (entityAttributes.firstname || ''));
				actionSuffix = entityID
			}

			if(this.hasRoleOption('showIDs', 'art_crm')){
				entityPrefix = '#' + entityID + ' - ' + entityPrefix
			}


			if(performActionGranted && refreshExistingTab && tabStrip && tabRegisterSecret !== undefined){
				performActionGranted = false

				let actionKey, action, wasInsertAction = false
				for(actionKey in this.actions){
					if(
						(action = this.actions[actionKey]) &&
						(
							(wasInsertAction = (action.originalActionKey === ('showInsert_' + type))) ||
							action.originalActionKey === ('showEdit_' + type)
						) &&
						(action.tabConnection || {}).tabRegisterSecret === tabRegisterSecret &&
						action.tabConnection.tabStripComponentIndex === tabStrip.componentIndex
					){
						if(wasInsertAction) {
							performActionGranted = true
							tabStrip.hideTab(tabRegisterSecret)
							afterActionCallback = function(){
								tabStrip.removeTab(tabRegisterSecret)
							}
						} else {
							tabStrip.refreshTab(tabRegisterSecret, {
								title: 	entityPrefix + ': ' + entityTitle,
								icon: 	entityIcon
							}, refreshTabContents)
						}
						break
					}
				}
			}

			if(performActionGranted){
				if(this.actions[baseActionKey]){
					return this.performAndStoreAction(
						baseActionKey + '_inEffect_' + actionSuffix,
						this.prepareAction(baseActionKey, undefined, {
							entity: 	{
								resourceID: entityID,
								mediaTitle,
							},
							relation: 	{
								entityID,
								activityYear: this.model.activityYear
							},
							tabOptions: {
								title: 	entityPrefix + ': ' + entityTitle,
								icon: 	entityIcon
							}
						})
					).then(function(context){
						if(afterActionCallback){
							return afterActionCallback()
						}
					})
				}
			}

			return utils.promise.reject()
		},

		async showEntityController(type, filters){
			if(type !== 'trip' && type !== 'cooperation'){
				return
			}

			for(const nav of $('.appContainer .templates_nav_nav')){
				const navComponent = getComponent(nav, true)
				if(navComponent){
					for(const navElement of navComponent.each()){
						const navAction = (((navElement || {}).attributes || {}).actions || {}).nav || {}

						let elementFound = false
						if(type === 'trip' && navAction.isTripNav) {
							this.model.tripTableShouldWaitForExternalFilters = true
							elementFound = true
						} else if(type === 'cooperation' && navAction.isCooperationNav) {
							this.model.cooperationTableShouldWaitForExternalFilters = true
							elementFound = true
						}

						if(elementFound && navElement.key){
							await navComponent.navToEntity(navElement.key)

							if(utils.collectionSize(filters) > 0){
								let filterComponent
								if(type === 'trip') {
									filterComponent = getComponent($('.templates_artCrm_trip_controller .templates_artCrm_trip_filter'), true)
								} else if(type === 'cooperation') {
									filterComponent = getComponent($('.templates_artCrm_cooperation_controller .templates_artCrm_cooperation_filter'), true)
								}

								if(filterComponent){
									filterComponent.model.dirtyFields = {
										data: {
											attributes: filters
										}
									}
									filterComponent.refresh(false)
								}
							}

							return
						}
					}
				}
			}
		}
	}
}